export enum ModulePath {
  MAIN = '/',
  APU = '/apu',
  INSTITUTION = '/institution',
  ORIGINATOR = '/originator',
  FUND = '/fund',
  FINDING_AID = '/finding-aid',
  ARCH_DESC = '/arch-desc',
  ENTITY = '/entity',
  NEWS = '/news',
  HELP = '/help',
}
